import { SingleRowCollapseType } from "./tax-card-single-row/tax-card-single-row.component";
import { SingleRowInputTypes } from "./tax-card-single-row/tax-card-single-row.component";
export class TaxCardSingleRow {
  public title: string;
  public subTitle: string;
  public labelBold: boolean;
  public inputLabel: string;
  public inputPlaceholder: string;
  public inputIsDisabled: Function;
  public inputSummaryLabel: string;
  public taxCardKey: string;
  public errors: string[];
  public validationErrorFieldNames: string[];
  public validationWarningFieldNames: string[];
  public subRows: TaxCardSingleRow[];
  public collapseType: SingleRowCollapseType;
  public inputType: SingleRowInputTypes;
  public tooltipTitle: string;
  public tooltipMessage: string;
  constructor(
    private _title?: string,
    private _labelBold?: boolean,
    private _inputLabel?: string,
    private _inputPlaceholder?: string,
    private _inputIsDisabled?: Function,
    private _inputSummaryLabel?: string,
    private _taxCardKey?: string,
    private _errors?: string[],
    private _validationErrorFieldNames?: string[],
    private _validationWarningFieldNames?: string[],
    private _subRows?: TaxCardSingleRow[],
    private _collapseType?: SingleRowCollapseType,
    private _inputType?: SingleRowInputTypes,
    private _subTitlte?: string,
    private _tooltipTitle?: string,
    private _tooltipMessage?: string
  ) {
    this.title = _title || "";
    this.labelBold = _labelBold || false;
    this.inputLabel = _inputLabel || "";
    this.inputPlaceholder = _inputPlaceholder || "";
    this.inputIsDisabled = _inputIsDisabled || (() => {});
    this.inputSummaryLabel = _inputSummaryLabel || "";
    this.taxCardKey = _taxCardKey || "";
    this.errors = _errors || [];
    this.validationErrorFieldNames = _validationErrorFieldNames || [];
    this.validationWarningFieldNames = _validationWarningFieldNames || [];
    this.subRows = _subRows || [];
    this.collapseType = _collapseType || null;
    this.inputType = _inputType || SingleRowInputTypes.PRICE;
    this.subTitle = _subTitlte || "";
    this.tooltipTitle = _tooltipTitle || "";
    this.tooltipMessage = _tooltipMessage || "";
  }
}
